import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/**
 * /accessibility.
 *
 * The legacy page's four sections were `<h4>`s under the H1, which skipped two levels;
 * they are the cards' `<h2>`s here, as on DiscountMags' accessibility statement. The words
 * are unchanged.
 */
export default function Accessibility() {
  return (
    <>
      {/* "Accessibility Statement", as the legacy trail said, not the rail's shorter label. */}
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Accessibility Statement' }]} />

      <PageHeading eyebrow="Customer Information">Accessibility at TopMags</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <h2>Digital Access for Everyone</h2>
          <p>
            TopMags is committed to providing a positive and inclusive shopping experience for all
            of our customers. Our goal is to enable all users to gather information and transact
            business through our website, regardless of their technology or ability.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>What We Are Doing</h2>
          <p>
            We are taking a proactive approach to website accessibility. Our team is currently
            auditing and updating our website code and design to conform with the Web Content
            Accessibility Guidelines (WCAG) 2.1 Level AA. This process involves testing our site
            with various assistive technologies, such as screen readers and screen magnifiers.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>A Work in Progress</h2>
          <p>
            We view accessibility as a journey, not a destination. As we add new products and
            features, we are constantly monitoring our site to ensure it remains accessible. If you
            do encounter a specific accessibility barrier, please know that it is unintentional, and
            we are likely already working on a fix.
          </p>
        </ContentCard>

        <ContentCard>
          <h2>Contact Us</h2>
          {/*
           * No bottom margin: this paragraph runs straight into the list it introduces,
           * which is what the legacy page's inline `margin-bottom: 0` did.
           */}
          <p className="mb-0">
            If you are having difficulty navigating TopMags.com or need assistance placing an order,
            please give us a call or send us an email. We are happy to assist you directly.
          </p>
          <ul>
            <li>
              <strong>Customer Service:</strong> (888)-886-7435
            </li>
            <li>
              <strong>Email Support:</strong>{' '}
              <a href="mailto:support@topmags.com">support@topmags.com</a>
            </li>
            <li>
              <strong>Availability: (EST/EDT Time Zone):</strong> Monday - Friday: 12:00 p.m. to
              8:00 p.m. Saturday - Sunday: Closed
            </li>
          </ul>
        </ContentCard>
      </div>
    </>
  );
}

Accessibility.layoutName = 'Layouts.Institutional';
